const formatMoney = (value, decimalPlaces, thousandSeparator, decimalSeparator) => {
  if (!value && value !== 0 && value !== '0') {
    return null;
  }
  const numericValue = Number(value);
  const sign = value < 0 ? '-' : '';
  const val = Math.abs(+value || 0).toFixed(decimalPlaces);
  const intVal = parseInt(val, 10);
  const intValStr = `${intVal}`;
  const j = intValStr.length > 3 ? intValStr.length % 3 : 0;

  const vall =
    (j ? intValStr.substr(0, j) + thousandSeparator : '') +
    intValStr.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousandSeparator}`);
  const decimal = Math.abs(numericValue - intVal)
    ? decimalSeparator +
      Math.abs(numericValue - intVal)
        .toFixed(decimalPlaces)
        .slice(2)
    : '';

  if (intVal !== 0) {
    return sign + vall + decimal;
  }
  return null;
};

export default formatMoney;
